import * as React from 'react';
import { useState } from 'react';
import {
  Box,
  Button,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  IconButton,
  MenuItem,
  FormControl,
  Select,
  SelectChangeEvent,
  OutlinedInput,
  ListItemText,
  Checkbox,
} from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import CreateButtonWithModal from '../components/common/CreateButtonWithModal';
import BlackWhiteSwitch from '../components/common/BlackWhiteSwitch';
import Typography from '@mui/material/Typography';
import DeleteButton from '../components/common/DeleteButton';
import EditModal from '../components/common/EditModal';
import Tooltip from '../components/common/Tooltip';

interface Column {
  id: keyof Data | 'action';
  label: string;
  minWidth?: number;
  align?: 'right' | 'center' | 'left';
}



const columns: readonly Column[] = [
  { id: 'name', label: 'Name', minWidth: 250 },
  { id: 'code', label: 'Code', minWidth: 80 },
  { id: 'citycode', label: 'City Code', minWidth: 100 },
  { id: 'countrycode', label: 'Country Code', minWidth: 120 },
  { id: 'timezone', label: 'Timezone', minWidth: 120 },
  { id: 'latitude', label: 'Latitude', minWidth: 100 },
  { id: 'longitude', label: 'Longitude', minWidth: 100 },
  { id: 'doms/Int', label: 'Dom/Int', minWidth: 100 },
  { id: 'Relevance - Traveler', label: 'Relevance - Traveler', minWidth: 180 },
  { id: 'Relevance - Flight', label: 'Relevance - Flight', minWidth: 180 },
  { id: 'status', label: 'Status', minWidth: 100 },
  { id: 'createdBy', label: 'Created By', minWidth: 120 },
  { id: 'action', label: 'Action', minWidth: 100, align: 'center' },
];

interface Data {
  name: string;
  code: string;
  citycode: string;
  countrycode: string;
  timezone: string;
  latitude: string;
  longitude: string;
  'doms/Int': string;
  'Relevance - Traveler': string;
  'Relevance - Flight': string;
  status: string;
  createdBy: string;
}

function createData(
  name: string,
  code: string,
  citycode: string,
  countrycode: string,
  timezone: string,
  latitude: string,
  longitude: string,
  domsInt: string,
  relevanceTraveler: string,
  relevanceFlight: string,
  status: string,
  createdBy: string
): Data {
  return {
    name,
    code,
    citycode,
    countrycode,
    timezone,
    latitude,
    longitude,
    'doms/Int': domsInt,
    'Relevance - Traveler': relevanceTraveler,
    'Relevance - Flight': relevanceFlight,
    status,
    createdBy,
  };
}

const initialRows: Data[] = [
  createData(
    'Indira Gandhi International Airport',
    'DEL',
    'DEL',
    'IN',
    'Asia/Kolkata',
    '28.5562',
    '77.1000',
    'International',
    'High',
    'High',
    'Active',
    'Admin'
  ),
  createData(
    'Heathrow Airport',
    'LHR',
    'LON',
    'UK',
    'Europe/London',
    '51.4700',
    '-0.4543',
    'International',
    'High',
    'High',
    'Active',
    'Emma'
  ),
  createData(
    'San Francisco International Airport',
    'SFO',
    'SFO',
    'US',
    'America/Los_Angeles',
    '37.6213',
    '-122.3790',
    'International',
    'Medium',
    'High',
    'Inactive',
    'John'
  ),
];

const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 8;
  const MenuProp = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 250,
      },
    },
    anchorOrigin: {
      vertical: 'bottom' as 'bottom',
      horizontal: 'left' as 'left',
    },
    transformOrigin: {
      vertical: 'top' as 'top',
      horizontal: 'left' as 'left',
    },
    getContentAnchorEl: null, // Important for older versions of MUI v4; can omit for MUI v5+
  };

const label = [
  'Name',
  'Code',
  'City Code',
  'Country Code',
  'Timezone',
  'Latitude',
  'Longitude',
  'Doms/Int',
  'Relevance - Traveler',
  'Relevance - Flight'
];

const Airports = () => {
  const [rows, setRows] = useState<Data[]>(initialRows);
  const [editOpen, setEditOpen] = useState(false);
  const [selectedRowIndex, setSelectedRowIndex] = useState<number | null>(null);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const handleChangePage = (_: unknown, newPage: number) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const handleEditSave = (updatedData: Data) => {
    if (selectedRowIndex === null) return;
    const updatedRows = [...rows];
    updatedRows[selectedRowIndex] = updatedData;
    setRows(updatedRows);
    setEditOpen(false);
  };

  const renderStatusButton = (status: string) => (
    <Button
      variant="contained"
      size="small"
      sx={{
        backgroundColor: status === 'Active' ? '#1cad2d' : '#e31a24',
        color: 'white',
        fontWeight: 'bold',
        textTransform: 'none',
        '&:hover': {
          backgroundColor: status === 'Active' ? '#2e7d32' : '#c62828',
        },
      }}
    >
      {status}
    </Button>
  );

  const handleDeleteRow = (code: string) => {
    const updatedRows = rows.filter((row) => row.code !== code);
    setRows(updatedRows);
    console.log(`Deleted row with code: ${code}`);
  };
  
  const renderActions = (row: Data, index: number) => (
    <>
      <IconButton
        color="primary"
        size="small"
        onClick={() => {
          setSelectedRowIndex(index);
          setEditOpen(true);
        }}
      >
        <EditIcon />
      </IconButton>
      <IconButton color="error" size="small">
        <DeleteButton
        onDelete={() => handleDeleteRow(row.code)}
        confirmMessage="Do you really want to delete this item?"
      />
        </IconButton>
    </>
  );
    

      const [labelName, setLabelName] = React.useState<string[]>([]);
              
                const labelChange = (event: SelectChangeEvent<typeof labelName>) => {
                  const {
                    target: { value },
                  } = event;
                  setLabelName(
                    // On autofill we get a stringified value.
                    typeof value === 'string' ? value.split(',') : value,
                  );
                };

  return (
    <>
      <Box className="headingBtnWrap">
      <Typography variant="h1">Airports</Typography>
        <CreateButtonWithModal modalTitle="Airports">
          <Box className="modalFormWrap">
        <Box component="form" className="modalForm">
        <Box className="form-control inputFieldWrap">
                <label>Name</label>
                <input type="text" className='inputField' />
            </Box>
            <div className="form-control inputFieldWrap">
                <label>Code</label>
                <input type="text" className='inputField' />
            </div>
            <div className="form-control inputFieldWrap">
                <label>City Code</label>
                <input type="text" className='inputField' />
            </div>
            <div className="form-control inputFieldWrap">
                <label>Country Code</label>
                <input type="text" className='inputField' />
            </div>
            <div className="form-control inputFieldWrap">
                <label>Dom/Int</label>
                <input type="text" className='inputField' />
            </div>
            <div className="form-control inputFieldWrap">
                <label>Relevance - Traveler</label>
                <input type="text" className='inputField' />
            </div>
            <div className="form-control inputFieldWrap">
                <label>Relevance - Flight</label>
                <input type="text" className='inputField' />
            </div>
        </Box>
        <Box display="flex" justifyContent="flex-end">
            <Button variant="contained" className='formBtn'>Save</Button>
            </Box>
            <BlackWhiteSwitch />
        </Box>
      </CreateButtonWithModal>
      </Box>
      <Box className="searchInputWrap">
                        <Box
                          display="flex"
                          alignItems="center"
                          gap={2}
                          p={2}
                          sx={{ width: '100%'}}
                          className="searchInputFilterBox"
                        >
                          <FormControl sx={{ minWidth: 460 }}>
                             <Select
                              className='leftFilterBox'
                              labelId="demo-multiple-checkbox-label"
                              id="demo-multiple-checkbox"
                              multiple
                              value={labelName}
                              onChange={labelChange}
                              displayEmpty
                              input={<OutlinedInput />}
                              renderValue={(selected) => {
                                if (selected.length === 0) {
                                  return 'Select';  // <-- Placeholder text
                                }
                                return selected.join(', ');
                              }}
                              MenuProps={MenuProp}
                            >
                              <MenuItem disabled value="">
                              Select
                              </MenuItem>
                              {label.map((name) => (
                                <MenuItem key={name} value={name} className='selectDropdown'>
                                  <Checkbox checked={labelName.includes(name)} />
                                  <ListItemText primary={name} />
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                          <Button
                                  variant="contained"
                                  className="searchBtn"
                                  color="primary"
                                  type="submit"
                                  sx={{ borderTopLeftRadius: 0, borderBottomLeftRadius: 0 }}
                                >
                                  Search
                                </Button>
                        </Box>
                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 2 }} className="dynamicInputFieldWrap">
                          {labelName.map((item) => (
                            <div key={item} className="form-control inputFieldWrap">
                              <label style={{ marginBottom: '4px', fontWeight: '500' }}>{item}</label>
                              <input
                                type="text"
                                // placeholder={`Enter ${item}`}
                                className="inputField"
                              />
                            </div>
                          ))}
                        </Box>
                      </Box>
      <Paper sx={{ width: '100%', overflowX: 'auto' }}>
        <TableContainer sx={{ maxHeight: 440 }}>
          <Table stickyHeader aria-label="sticky table">
            <TableHead>
              <TableRow>
                {columns.map((column) => (
                  <TableCell
                    key={column.id}
                    align={column.align || 'left'}
                    style={{ minWidth: column.minWidth }}
                  >
                    {column.label}
                  </TableCell>
                ))}
                <TableCell sx={{ minWidth: 100 }} align="center">Audit Trail</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
            {rows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row, rowIndex) => (
                  <TableRow hover key={rowIndex}>
                    {columns.map((column) => {
                      const value = row[column.id as keyof Data];
                      if (column.id === 'status') {
                        return <TableCell key={column.id}>{renderStatusButton(value)}</TableCell>;
                      }
                      if (column.id === 'action') {
                        return (
                          <TableCell key={column.id} align="center">
                            {renderActions(row, rowIndex)}
                          </TableCell>
                        );
                      }
                      
                      
                      return <TableCell key={column.id}>{value}</TableCell>;
                    })}
                    <TableCell align="center">
                      <Tooltip />
                    </TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          rowsPerPageOptions={[10, 25, 100]}
          component="div"
          count={rows.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </Paper>

      {/* Edit Modal */}
        {selectedRowIndex !== null && (
          <EditModal
            open={editOpen}
            onClose={() => setEditOpen(false)}
            initialData={rows[selectedRowIndex]}
            onSave={handleEditSave}
            excludeFields={['action', 'status']}
            readOnlyFields={['createdBy']}
            title="Edit Airports"
          />
        )}
    </>
  );
};

export default Airports;
